/**
 * Created by anthony on 6/24/14.
 */

var vehicleModel = angular.module('vehicleModel', ['familyModel']);
vehicleModel.factory('VehicleModelFactory', function(ApplicationService, AbstractModelService, FamilyModelFactory){
    var VehicleModel = function(familyID){
        this.familyID = familyID;
        this.dataProperty = "vehicle";
        this.endpoint = "/vehicle";
        this.primaryKey = "recordID";
        this.data = angular.copy(this.get());
    }
    VehicleModel.prototype = new FamilyModelFactory();
    VehicleModel.prototype.parent = FamilyModelFactory.prototype;
    VehicleModel.prototype.new = function(fam)
    {
        return ApplicationService.getFamilyData().vehicle.push(
            {
                Veh_Make: '', xVeh_Make: 'New', Veh_Year: '', Veh_EMV: '', Veh_Debt_Out: '', Veh_Payment_Val: '',
                Veh_Payment: '', Veh_Lease: '', Veh_Complete: 0, Veh_Holds: 0, added: 1
            }
        ) - 1;
    }

    VehicleModel.prototype.put = function(id, data, instance)
    {
        return AbstractModelService.put("/api/family/" + this.familyID + "/vehicle/" + id, data, instance);
    }

    VehicleModel.prototype.post = function(id, data, instance)
    {
        return AbstractModelService.post("/api/family/" + this.familyID + "/vehicle", data, instance);
    }

    VehicleModel.prototype.purge = function(id, data, instance)
    {
        return AbstractModelService.purge("/api/family/" + this.familyID + "/vehicle/" + id, data, instance);
    }

    VehicleModel.prototype.updateData = function() //Abstract
    {
        this.data = angular.copy(this.get());
        ApplicationService.getFamilyData().vehicle = angular.copy(this.data);
    }

    return VehicleModel;
});